import React, { type FC } from 'react';
import Grid from '@mui/material/Grid';
import { type ToDo, ToDoCard, ToDoCardSkeleton } from 'components/ToDos';
import { useTranslation } from 'react-i18next';


interface DashboardToDosGridProps {
    toDos: ToDo[] | undefined,
    loading: boolean
}

export const DashboardToDosGrid: FC<DashboardToDosGridProps> = ({ toDos, loading }) => {
    const { t } = useTranslation('dashboard', { useSuspense: false });
    
    return (
        loading
        ? <Grid className="dashboard_todos_container" container spacing={3}>
            {Array.from({ length: toDos?.length || 10 }).map((_, index) => (
                <Grid item key={index}>
                    <ToDoCardSkeleton />
                </Grid>
            ))}
        </Grid>
        : toDos && toDos.length > 0
            ? <Grid className="dashboard_todos_container" container spacing={3}>
                {
                    toDos.map((toDo, index) => (
                        <Grid item key={index}>
                            <ToDoCard toDo={toDo}/>
                        </Grid>
                        )
                    )
                }
            </Grid>
            : <div>{t('dashboard_no_todos_message', 'No pending To-dos')}</div>
    )
}